export const config = {
  server: {
    baseUrl: process.env.REACT_APP_SERVER_BASEURL || '', // fallback to empty string
    uri: {
      getecompinfo: 'api/getecompinfo/',
    },
  },
};
